<template>
    <div class="card-body bg-white">
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="new_contact_name"
                   :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
            <input v-model="newContactForm.name" id="new_contact_name" name="name"
                   maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newContactForm.errors.has('name')}">
            <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                    newContactForm.errors.get('name')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0" for="email"
                   :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
            <input
                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                :class="{'border-red': newContactForm.errors.has('email')}"
                type="text" id="email" v-model="newContactForm.email">
            <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                    newContactForm.errors.get('email')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0" for="cell"
                   :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
            <input
                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                type="text" id="cell" v-model="newContactForm.cell">
            <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                    newContactForm.errors.get('cell')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                   :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
            <input
                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                type="text" id="new_contact_title" v-model="newContactForm.title">
            <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                    newContactForm.errors.get('title')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"
                   :class="{'text-red': newContactForm.errors.has('date')}">Follow Up</label>
            <div class="flex">
                <datetime type="datetime" id="new_contact_date" name="date"
                          v-model="newContactForm.date" use12-hour
                          class="w-full"
                          :format="masks.date_time_mask"
                          input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                          @input="newContactForm.errors.clear('date')">
                </datetime>
                <button  type="button" v-if="newContactForm.date" @click.prevent.stop="removeNewContactDate"
                         class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                </button>
            </div>
            <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{
                    newContactForm.errors.get('date')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0"
                   :class="{'text-red': newContactForm.errors.has('contact_types_id')}">Contact
                Type</label>
            <multiselect
                class="cursor-pointer"
                :options="contactTypes"
                v-model="selectedContactType"
                :show-labels="false"
                @input="newContactForm.errors.clear('contact_types_id')"
                track-by="id"
                label="code"
                value="id">
            </multiselect>
            <div class="text-red text-xs" v-if="newContactForm.errors.has('contact_types_id')">{{
                    newContactForm.errors.get('contact_types_id')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-sm text-grey-darkest -mb-0"
                   :class="{'text-red': newContactForm.errors.has('user')}">User</label>
            <multiselect
                class="cursor-pointer"
                :options="usersForContact"
                v-model="newContactForm.user"
                :show-labels="false"
                @input="newContactForm.errors.clear('user')"
                track-by="id"
                label="name"
                value="id">
            </multiselect>
            <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                    newContactForm.errors.get('user')
                }}
            </div>
        </div>
        <div class="mb-2">
            <contact-custom-fields ref="ContactCustomFields" base="create" :isGenericFormRequest="true" :customFieldErrors="newContactForm.errors"></contact-custom-fields>
        </div>
        <div class="mb-2" style="text-align: right;">
            <button type="button" @click="submit()" class="btn btn-primary" :disabled="createProcessing">
                <i v-if="createProcessing" class="fa fa-spin fa-spinner" aria-hidden="true"></i>&nbsp;
                Create & Add
            </button>
        </div>
    </div>
</template>

<script>
import ContactCustomFields from "../contact/custom-fields/contact-custom-fields.vue";
import Multiselect from "vue-multiselect";
import Form from "../../utils/form";
import axios from "axios";
export default {
    name: 'contact-create-form',
    components: {Multiselect, ContactCustomFields},
    props: ['company', 'masks'],
    data() {
        return {
            newContactForm: new Form({
                name: null,
                email: null,
                cell: null,
                title: null,
                date: null,
                completed: null,
                contact_types_id: null,
                user: null,
                customFieldsData: null,
                new_company: null,
                existing_company: this.company ?? null,
            }),
            contactTypes: [],
            selectedContactType: null,
            selects: [],
            usersForContact: [],
            createProcessing: false
        }
    },
    watch: {
        selectedContactType: function(val, oldVal) {
            this.newContactForm.contact_types_id = val ? val.id : null;
        }
    },
    mounted() {
        this.getContactTypes();
        this.fetchCodes();
    },
    methods: {
        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                self.contactTypes = data.filter(x => !x.is_residential)
                self.contactTypes.push({id:null,code:""})
            });
        },
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                this.usersForContact = this.selects.users;
            });
        },
        submit() {
            let self = this;
            self.createProcessing = true;
            self.newContactForm.customFieldsData = self.$refs.ContactCustomFields.form;
            let data = {
                existing_company: self.company.id,
                check_email: true,
                triggerAutomation: true
            };

            this.newContactForm.post(route('api.add-contact', {data: data})).then((response) => {
                self.createProcessing = false;
                if (response.exists){
                    self.getToast().fire({
                        type: 'error',
                        title: response.message,
                    });
                }
                else {
                    if(response.new_contact) {
                        self.resetCreateForm();
                        self.$refs.ContactCustomFields.form = null;
                        self.$refs.ContactCustomFields.fetchCustomFields();
                        self.getToast().fire({
                            type: 'success',
                            title: 'Contact created successfully!',
                        });
                        self.$emit('contactCreated');
                    }
                }
            }).catch((error) => {
                self.createProcessing = false;
            });
        },
        resetCreateForm() {
            this.newContactForm.name = null;
            this.newContactForm.email = null;
            this.newContactForm.cell = null;
            this.newContactForm.title = null;
            this.newContactForm.date = null;
            this.newContactForm.completed = null;
            this.newContactForm.contact_types_id = null;
            this.newContactForm.user = null;
            this.newContactForm.customFieldsData = null;
            this.newContactForm.new_company = null;
            this.newContactForm.errors.errors = {};
            this.selectedContactType = null;
        },
    }
}
</script>

<style scoped>

</style>
